import { Navigate, Outlet } from "react-router";
import { BRAND, CREATE, DELETE, MODIFY, useFoodpilotContext } from "src/context/FoodpilotContext";
import type { Slugs } from "src/context/ProtectedContext";

type BrandsProtectionProps = {
    action?: Slugs;
};

export const BrandsProtection = (props: BrandsProtectionProps) => {
    const { canUser } = useFoodpilotContext();
    const canAccessBrands =
        props.action ?
            canUser(props.action, BRAND)
        :   canUser(CREATE, BRAND) || canUser(MODIFY, BRAND) || canUser(DELETE, BRAND);

    if (!canAccessBrands) {
        return <Navigate to="/settings" replace />;
    }

    return <Outlet />;
};
